export default {
  section_title: 'Gestionare taxe',
  inherited_from_partner: 'Preluat',
  inherited_from_region: 'Standard regional',
  reset: 'Resetează la valoarea preluată',
  form: {
    tax_name: {
      label: 'Denumire taxă',
      tooltip: 'Cum este denumită taxa pe bonuri și facturi, de exemplu TVA sau GST.',
    },
    tax_behaviour: {
      label: 'Gestionare taxe',
      tooltip: 'Dacă prețurile din meniu includ deja taxa sau taxa se adaugă la finalizarea comenzii.',
      options: {
        inclusive: 'Inclusă în prețurile din meniu',
        exclusive: 'Adăugată la finalizarea comenzii',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Cota de taxă pentru taxa de livrare',
      tooltip: 'Cota la care este taxată propria taxă de livrare, care poate diferi de cota pentru alimente.',
    },
  },
  impact: {
    title: 'Modificați gestionarea taxelor pentru restaurantele dvs.?',
    affected_one: '{{count}} restaurant urmează setarea implicită și se va modifica.',
    affected_few: '{{count}} restaurante folosesc setarea implicită și se vor modifica.',
    affected_other: '{{count}} restaurante urmează setarea implicită și se vor modifica.',
    overriding_one: '{{count}} restaurant are propria setare și o va păstra.',
    overriding_few: '{{count}} restaurante au setare proprie și o vor păstra.',
    overriding_other: '{{count}} restaurante au propria setare și o vor păstra.',
    confirm: 'Modifică-le',
  },
  buttons: {
    save: 'Salvează',
    cancel: 'Anulează',
  },
  toasts: {
    load_error: 'Încărcarea setărilor de taxe a eșuat',
    impact_error: 'Verificarea restaurantelor afectate a eșuat',
    impact_changed_one: 'Numărul de restaurante afectate s-a schimbat la {{count}}. Verificați și salvați din nou.',
    impact_changed_few: 'Numărul restaurantelor afectate s-a schimbat la {{count}}. Verifică și salvează din nou.',
    impact_changed_other: 'Numărul de restaurante afectate s-a schimbat la {{count}}. Verificați și salvați din nou.',
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
